const selectors = {
    el: '.js-collapsible-question:not(.is-ready)',
    title: '.js-collapsible-question__title'
}

const classes = {
    active: 'faq-questions__item--active'
}

const build = el => {
    el.classList.add('is-ready');
    const questionTitle = el.querySelector(selectors.title);
    questionTitle.addEventListener('click', () => {
        el.classList.toggle(classes.active);
    });
}

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(build);
}

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;